import React from 'react';
import {
  ATMHeader,
  ATMSegment,
  ATMGrid,
  ATMField,
  ATMForm,
} from 'shared-it-appmod-ui';
import { useFireFightingDispatchContext } from 'src/contexts/fire-fighting-dispatch.context';
import Lang from 'src/libraries/language';
import { INewFireDispatchMethods } from 'src/models/fire-fighting-dispatch.model';

type IProps = INewFireDispatchMethods;

const FireInformationForm: React.FC<IProps> = ({ control, errors }) => {
  const { state } = useFireFightingDispatchContext();
  return (
    <ATMSegment>
      <ATMHeader>{Lang.TTL_FIRE_DISPATCH_FIRE_INFORMATION}</ATMHeader>
      <ATMGrid columns={4}>
        <ATMGrid.Row>
          <ATMGrid.Column>
            <ATMField
              name="burnedAcres"
              width={12}
              label={Lang.LBL_FIRE_DISPATCH_ACRES_BURNED}
              type="number"
              as={ATMForm.Input}
              placeholder={Lang.LBL_ENTER}
              control={control}
              error={errors.burnedAcres}
            />
          </ATMGrid.Column>
          <ATMGrid.Column>
            <ATMField
              name="fireAgency"
              width={12}
              label={Lang.LBL_FIRE_DISPATCH_FIRE_AGENCY}
              as={ATMForm.Select}
              placeholder={Lang.LBL_SELECT_ONE}
              control={control}
              options={state.fireAgency.map((value) => ({
                key: value.agencyId,
                value: value.name,
                text: value.name,
              }))}
              onChange={([_, { value }]) => value}
              error={errors.fireAgency}
            />
          </ATMGrid.Column>
          <ATMGrid.Column>
            <ATMField
              name="fireName"
              width={12}
              label={Lang.LBL_FIRE_DISPATCH_FIRE_NAME}
              as={ATMForm.Input}
              placeholder={Lang.LBL_ENTER}
              control={control}
              error={errors.fireName}
            />
          </ATMGrid.Column>
        </ATMGrid.Row>
        <ATMGrid.Row>
          <ATMGrid.Column width={10}>
            <ATMField
              name="fireComments"
              width={12}
              label={Lang.LBL_FIRE_DISPATCH_FIRE_COMMENTS}
              as={ATMForm.TextArea}
              control={control}
              error={errors.fireComments}
            />
          </ATMGrid.Column>
        </ATMGrid.Row>
      </ATMGrid>
    </ATMSegment>
  );
};

export default FireInformationForm;
